
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

/**
 * "Open in maps" + "mark as visited" actions of a route stop. On touch-sized screens both become large,
 * full-width buttons so drivers can hit them reliably while on the move.
 */
@Component({name: 'RouteLegActions'})
export default class RouteLegActions extends Vue {
  @Prop({default: null}) protected mapUrl!: string | null;
  @Prop({default: false}) protected visited!: boolean;
  @Prop({default: false}) protected loading!: boolean;
  @Prop({default: true}) protected toggleable!: boolean;

  protected get touch(): boolean {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
